<template>
  <app-modal
    :modal-id="modalId"
    modal-alignment="top"
    modal-size="fullscreen"
    @close-modal="closeModal"
  >
    <template slot="header">
      <h5 class="modal-title">{{title}}</h5>
      <button
        type="button"
        class="close outline-none"
        data-dismiss="modal"
        aria-label="Close"
      >
        <span>
          <app-icon :name="'x'"></app-icon>
        </span>
      </button>
    </template>
    <template slot="body">
      <div class="card card-with-search border-0 card-with-shadow">
        <div class="text-justify">
          <app-tab :tabs="tabsHorizontal" type="horizontal" />
        </div>
      </div>
    </template>

    <template slot="footer">
      <button
        type="button"
        class="btn btn-secondary mr-2"
        data-dismiss="modal"
        @click="closeModal"
      >
        {{ $t("close") }}
      </button>
      <!-- <button
        type="button"
        class="btn btn-primary mr-2"
        data-dismiss="modal"
        @click="submit"
      >
        {{ $t("update") }}
      </button> -->
    </template>
  </app-modal>
</template>

<script>
import { ModalMixin } from "../../../../../../../app/Mixins/ModalMixin";
// import { FormMixin } from "../../../../../core/mixins/form/FormMixin.js";
// import { TableHelpers } from "../../Demo/Tables/mixins/TableHelpers";
import CoreLibrary from "../../../../../../../core/helpers/CoreLibrary.js";

export default {
  name: "Tabs",
  extends: CoreLibrary,
  mixins: [ModalMixin],
  props: {
    id: Number,
    getSite: Function,
    title:String,
  },
  data() {
    return {
      modalId: "my_task_modal",
      icon: "settings",
      isAddEditModalActive: false,
      tabsHorizontal: [
        {
          icon: "info",
          name: "Edit Task",
          component: "job-site-task-update",
          permission: "",
          props: { id: this.id, getSite: this.getSite },
        },
        {
          icon: "link",
          name: "Forms",
          component: "task-form-mainstep",
          permission: "",
          props: { id: this.id },
        },
      ],
    };
  },
};
</script>
